import { BookOpen, ExternalLink } from 'lucide-react';

/**
 * /admin/knowledge — moved to the Training Hub (2026-10-27).
 *
 * Mr. Bubbles' knowledge base is edited in the Training Hub
 * (Alameda-Point-Beverage-Group/apbg-training-studio). The DATABASE is the one
 * copy: the hub saves through this repo's admin-kb-docs, which still chunks,
 * embeds and audit-logs every document. The phone agent's coaching notes moved
 * with it (admin-voice-teachings). See docs/RAG-SUPPORT-CHAT.md.
 */
const HUB_URL = 'https://apbg-training-hub.netlify.app/training/#/knowledge';

export default function AdminKnowledge() {
  return (
    <div className="mx-auto max-w-2xl rounded-xl border border-brix-border bg-brix-surface p-6">
      <div className="mb-2 flex items-center gap-2 text-brix-ink">
        <BookOpen className="h-5 w-5" />
        <h1 className="text-lg font-bold">The knowledge base moved to the Training Hub</h1>
      </div>
      <p className="mb-4 text-sm text-brix-muted">
        Add, edit and delete Mr. Bubbles&apos; documents, choose who sees each one, review the questions
        it could not answer, and manage the phone agent&apos;s coaching notes — all in the Training
        Hub, with the same login. Customers notice nothing: the portal, the website assistant and the
        phone agent answer from the same documents as before.
      </p>
      <a
        href={HUB_URL}
        className="inline-flex items-center gap-2 rounded-lg bg-brix-primary px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
      >
        Open the knowledge base <ExternalLink className="h-4 w-4" />
      </a>
    </div>
  );
}
